import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const inputCls = "mt-1.5 rounded-none bg-background border-border h-9";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("New passwords do not match");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border rounded-none text-foreground max-w-sm">
        <DialogHeader><DialogTitle className="font-heading font-black tracking-tighter text-2xl">CHANGE PASSWORD</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="uppercase text-[10px] tracking-[0.2em] font-bold text-muted-foreground">Current password</Label>
            <Input data-testid="current-password-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
          </div>
          <div>
            <Label className="uppercase text-[10px] tracking-[0.2em] font-bold text-muted-foreground">New password</Label>
            <Input data-testid="new-password-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
          </div>
          <div>
            <Label className="uppercase text-[10px] tracking-[0.2em] font-bold text-muted-foreground">Confirm new password</Label>
            <Input data-testid="confirm-password-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          </div>
          <Button data-testid="save-password-button" onClick={submit} disabled={saving} className="w-full rounded-none bg-[#FF3B30] hover:bg-[#ff554b] font-bold uppercase tracking-widest text-xs h-11">
            {saving ? "Saving…" : "Change password"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
